module.exports = __webpack_public_path__ + "static/media/shikimico-logo.99fbb111.svg";